import {
    Ecommerce as ListingsEcommerce,
    Taxonomy as OnlyListingsTaxonomy
} from './listings';

import { Taxonomy as OnlyListingTaxonomy } from './listing';
import { Ecommerce as LeadEcommerce } from './lead';

type Values<T> = T[keyof T];

export interface TrackingContract {
    baselayer: Baselayer;
    taxonomy?: Taxonomy | Record<string, unknown>;
    ecommerce?: Ecommerce;
}

export const TaxonomyPage = {
    HOMEPAGE: '/homepage/',
    HOME_VALUES: '/home-values/',
    VALUATION: '/valuation/',
    PRIVACY: '/privacy/',
    DISCOVER: '/discover/',
    PROPERTY: '/property/details/', // Not the actual URL, but differentiates from other /property/ URLs
    FOR_SALE_SEARCH_RESULTS: '/for-sale/results/',
    FOR_SALE_DETAILS: '/for-sale/details/',
    TO_RENT_SEARCH_RESULTS: '/to-rent/results/',
    TO_RENT_DETAILS: '/to-rent/details/',
    NEW_HOMES_SEARCH_RESULTS: '/new-homes/results/',
    NEW_HOMES_DETAILS: '/new-homes/details/',
    SIGN_IN: '/signin/',
    REGISTER: '/register/'
} as const;

export const TaxonomySection = {
    HOMEPAGE: 'homepage',
    HOME_VALUES: 'home-values',
    HOUSE_PRICES: 'house-prices',
    FOR_SALE: 'for-sale',
    TO_RENT: 'to-rent',
    NEW_HOMES: 'new-homes',
    PRIVACY: 'privacy',
    DISCOVER: 'discover',
    SIGN_IN: 'signin',
    REGISTER: 'register'
} as const;

export type BaseTaxonomy = {
    section: Values<typeof TaxonomySection>;
    page: Values<typeof TaxonomyPage>;
    countryCode?:
        | 'gb'
        | 'es'
        | 'fr'
        | 'us'
        | 'pt'
        | 'it'
        | 'ie'
        | 'gr'
        | 'de'
        | 'za'
        | 'ch'
        | 'th'
        | 'tr'
        | 'cy'
        | 'ae';
    signedInStatus?: 'signed in' | 'signed out';
    brand: string;
    brandPrimary?: string;
    os?: string;
    platform?: 'desktop' | 'responsive' | 'mobile' | 'React';
    path?: string;
    listingsCategory?: 'residential' | 'development';
    activity?:
        | 'listing_search'
        | 'listing_details'
        | 'listing_contact'
        | 'editorial'
        | 'development details page';
    aboutMeStatus?: string;
    device?: string;
    editorialFormat?: string;
    editorialTopic?: string[];
    sharePlatform?: 'facebook' | 'twitter' | 'copy link';
    userId: string;
};

export type Baselayer = {
    session_id?: string;
    instance_id?: string;
    device_id?: string;
    session_count?: number;
};

export type Ecommerce = ListingsEcommerce | LeadEcommerce;

export type Taxonomy = BaseTaxonomy | ListingsTaxonomy | ListingTaxonomy;
export type ListingsTaxonomy = BaseTaxonomy & OnlyListingsTaxonomy;
export type ListingTaxonomy = BaseTaxonomy & OnlyListingTaxonomy;

export const EventNames = {
    SEARCH: 'Search',
    SEARCH_RESULT_IMPRESSION: 'Search Result Impression',
    VIEWED_PAGE: 'Viewed Page',
    LEAD_SENT: 'Lead Sent',
    CLICK_SEARCH_RESULT: 'Search Result Click',
    CLICK_SAVE_SEARCH: 'Click Save Search',
    CLICK_SAVE_SEARCH_SUBMITTED: 'Click Save Search Submitted',
    CLICK_EMAIL_PROPERTY_ALERT: 'Click Email Property Alert',
    CLICK_EMAIL_PROPERTY_ALERT_SUBMITTED:
        'Click Email Property Alert Submitted',
    CLICK_CALL_AGENT: 'Click Call Agent',
    CLICK_EMAIL_AGENT: 'Click Email Agent',
    CLICK_SAVE_LISTING: 'Click Save Listing',
    CLICK_BOOK_AGENT_VALUATION: 'Click Book Agent Valuation',
    DEVELOPMENT_LEAD: 'Development Lead',
    SHARE_CONTENT: 'Share Content',
    EMAIL_OPT_IN: 'Email Marketing Opt-In',
    REGISTRATION: 'Registration',
    SIGN_IN: 'Sign In'
} as const;

export type EventNamesList = Values<typeof EventNames>;

export type IdentifyTrait = {
    user_uuid?: string | null;
};
